import { Injectable } from '@angular/core';
import {
    HttpErrorResponse,
    HttpEvent,
    HttpHandler,
    HttpInterceptor,
    HttpRequest
} from '@angular/common/http';
import { MatDialog } from '@angular/material/dialog';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

import { ErrorDialogComponent } from '@emm/shared/dialogs/error-dialog/error-dialog.component';

@Injectable()
export class HttpRequestInterceptor implements HttpInterceptor {

    constructor(public dialog: MatDialog) {}

    intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        return next.handle(request).pipe(catchError(this.handleError));
    }

    private handleError(error: HttpErrorResponse) {
        if (error.status === 0) {
            return this?.openErrorDialog();
        }

        console.error(
            `Backend returned code ${error.status}, ` +
            `body was: ${error.error?.error?.message || error.error}`
        );

        return throwError(error);
    }

    private openErrorDialog() {
        const dialogRef = this.dialog.open(ErrorDialogComponent, {
            width: '300px',
            height: '300px',
        });

        return dialogRef.afterClosed().pipe(
            tap((res) => {
                if (res === 'retry') {
                    location.reload();
                }
            })
        );
    }
}
